import i18n from "../../../../../../../constants/i18n";
import { TGender } from "../../../../../../../Types";
import Et3Image from "../../../../../../../core/et3-Image";
import ET3Div from "../../../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../../../core/et3-enhanced-render";

const SenderIcon = withLiteObserverAndTheme<{
  isLastInSubGroup: boolean;
  isKhattabaMessage: boolean;
  isClientMessage: boolean;
  isOneOOneMConversation: boolean;
  senderGender: TGender;
}>((props) => {
  const {
    isKhattabaMessage,
    isLastInSubGroup,
    isClientMessage,
    isOneOOneMConversation,
    senderGender
  } = props;
  const { theme } = props;
  const { colors } = theme;
  const isMatchSender = !isKhattabaMessage && !isClientMessage;
  const imageNamePart = isMatchSender ? "match" : "client";
  const imageName = `${senderGender}-${imageNamePart}-icon`;

  return (
    <ET3Div
      width={60}
      height={60}
      alignItems={"center"}
      fDirection={"row"}
      color={colors.all.transparent}
      justifyContent={"flex-end"}
      withShadow={false}
      isExtendable={false}
      isScrollable={false}
      onClick={() => {}}
      style={{}}
    >
      {isLastInSubGroup && !isKhattabaMessage && !isOneOOneMConversation ? (
        <Et3Image
          type="LOCAL"
          alt={i18n.get("ALKHATTABA_ADMIN")}
          imageName={imageName}
          size={50}
          onClick={() => {}}
          style={{}}
        />
      ) : null}
    </ET3Div>
  );
});

export default SenderIcon;
